import { getRandomBetween } from "../utils";

export default function createFurdlandQueen() {
  const pattern = getRandomBetween(0.1, 0.99);

  const layingVigor = getRandomBetween(0.1, 0.99);
  const honey = getRandomBetween(0.1, 0.99);
  const diseaseResistance = getRandomBetween(0.1, 0.99);
  const swarmTendency = getRandomBetween(0.1, 0.99);
  const aggression = getRandomBetween(0.1, 0.99);
  const miteResistance = getRandomBetween(0.1, 0.99);
  const overWinter = getRandomBetween(0.1, 0.99);

  let queenStats = {
    haveQueen: true,
    layingVigor: layingVigor,
    pattern: pattern,
    honey: honey,
    diseaseResistance: diseaseResistance,
    swarmTendency: swarmTendency,
    droneTendency: 0.05,
    aggression: aggression,
    virgin: false,
    laying: true,
    miteResistance: miteResistance,
    overwinter: overWinter,
    breed: "Furdland",
    birth: new Date().getTime(),
  };
  return queenStats;
}
